var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center p-3"},[_c('div',{class:[_vm.displayInline ? 'mr-2' : 'd-block mb-3']},[_c('b-spinner',{class:[_vm.small ? 'small' : 'spinner-large'],attrs:{"label":"Loading...","variant":"secondary"}})],1),_c('span',{staticClass:"text-secondary",class:_vm.small ? '' : 'spinner-message'},[_vm._v(_vm._s(_vm.message))])])
}
var staticRenderFns = []

export { render, staticRenderFns }